import { render, staticRenderFns } from "./document-dialog.vue?vue&type=template&id=52f2920c&scoped=true"
import script from "./document-dialog.vue?vue&type=script&lang=js"
export * from "./document-dialog.vue?vue&type=script&lang=js"
import style0 from "./document-dialog.vue?vue&type=style&index=0&id=52f2920c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f2920c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52f2920c')) {
      api.createRecord('52f2920c', component.options)
    } else {
      api.reload('52f2920c', component.options)
    }
    module.hot.accept("./document-dialog.vue?vue&type=template&id=52f2920c&scoped=true", function () {
      api.rerender('52f2920c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/entries/components/document-dialog.vue"
export default component.exports